import React, { useState } from "react";
import { Box, Button, Stack, TextField } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useSearchStore } from "../store/store";

const SearchField = () => {
    const { setSearchText } = useSearchStore();
    const [ searchValue, setSearchValue ] = useState('');

    const handleSearch = () => {
        setSearchText(searchValue);
        window.location.href = `/#/search`;
        setSearchValue('');
    }
    
    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={0.25}
            sx={{
                height: '24px',
                padding: 0,                
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                    placeholder="Search for artists, albums, tracks..."
                    variant="outlined"
                    size="small"
                    sx={{          
                        height: '24px',              
                        width: '180px',
                        borderRadius: '4px',
                        // Targets the inner text box container padding
                        '& .MuiInputBase-root': {
                            height: '24px', 
                            padding: '2px 8px',
                        },
                        // Safely adjusts the font size of the text inside
                        '& .MuiInputBase-input': {
                            fontSize: '0.875rem',
                            padding: '0 !important',
                        }
                    }}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            handleSearch();
                        }
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                    variant="contained"
                    size="small"
                    sx={{
                        backgroundColor: '#3473bb',
                        height: '24px',
                        minWidth: '32px',
                        padding: '2px'
                    }}
                    onClick={handleSearch}
                >
                    <FontAwesomeIcon icon={faSearch} />
                </Button>
            </Box>
        </Stack>
    )
}

export default SearchField;
